export default "__VITE_ASSET__BjcLsJzz__"